import { APIDecoratorWithBaseURI } from '../../Service/api'

/**
 * Busca a URL assinada (pré-signed) do termo de uso da base de mailing.
 *
 * O PDF do termo fica em um bucket S3 privado. O backend gera uma URL de curta
 * duração a cada chamada, então nada do S3 (bucket, caminho) é exposto no
 * front e o arquivo só é acessível de forma autenticada e temporária.
 *
 * Backend esperado: GET producer/analytics/mailingTerms
 *   -> { success: true, data: { url: '<pre-signed url>' } }
 */
export const useMailingTerms = () => {
  const url = 'producer/analytics/mailingTerms'

  const fetchMailingTermsUrl = async (): Promise<string | null> => {
    const response = await APIDecoratorWithBaseURI().get(url)

    const body = response?.data
    if (body?.success && body?.data?.url) {
      return body.data.url as string
    }

    return null
  }

  return { fetchMailingTermsUrl }
}
